import { render, staticRenderFns } from "./AdverseEventMandatoryModal.vue?vue&type=template&id=60abad70"
import script from "./AdverseEventMandatoryModal.vue?vue&type=script&lang=js"
export * from "./AdverseEventMandatoryModal.vue?vue&type=script&lang=js"
import style0 from "./AdverseEventMandatoryModal.vue?vue&type=style&index=0&id=60abad70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports